import React, { useState, useEffect } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import "react-circular-progressbar/dist/styles.css";
import apiService from '../../../services/apiService'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Modal from 'react-modal';
import InviteUserModal from '../modal/inviteUserModal';
import CustomToast from '../../Toast';
import Loader from '../../layouts/loader';
import DeleteOrgUserModal from '../modal/deleteOrgUserModal';

const Admin = () => {

    const [show, setShow] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [userId, setUserId] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [org_flag, setOrgFlag] = useState(true);
    const [ic_flag, setIcFlag] = useState('');
    const [ic_designation, setIcDesignation] = useState('');
    const [post_of_ic_member, setPostOfIcMember] = useState('');
    const [ic_location, setIcLocation] = useState('');
    const [tenure_from, setTenureFrom] = useState('');
    const [tenure_to, setTenureTo] = useState('');
    const [phone, setPhone] = useState('');
    const [courseLicenseList, setCourseLicenseList] = useState([]);
    const [icUserList, setIcUserList] = useState([]);
    const [icOrgList, seticOrgList] = useState([]);
    const [inviteModalIsOpen, setInviteModalIsOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [userData, setUserData] = useState()
    const [selectedValue, setSelectedValue] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [totalCount, setTotalCount] = useState(0)
    const [selectedUser, setSelectedUser] = useState();
    const [deleteOrgUserModalIsOpen, setDeleteOrgUserModalIsOpen] = useState(false);
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
    const [openDropdownType, setOpenDropdownType] = useState(null); 
    const [modalType, setModalType] = useState('admin'); // 'admin' or 'ic'
    const percentage = 0;
    const navigate = useNavigate();
    let orgInfo = JSON.parse(localStorage.getItem("orgInfo"));


    useEffect(() => {
        requestAnimationFrame(() => {
            window.scrollTo(0, 0);
        });
        let userDetail = sessionStorage.getItem("userDetail")
        if (userDetail) {
            userDetail = JSON.parse(userDetail)
            setUserData(userDetail)
        }
        setLoader(true);
        fetchCourseLicenses(userDetail);
        fetchIcMemberList();
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [currentPage])

        // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.action-dropdown')) {
                setOpenDropdownIndex(null);
                setOpenDropdownType(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openDropdownIndex]);


    const fetchCourseLicenses = (userDetail) => {
        setLoading(true);
        setLoader(true);
        const token = apiService.getAuthToken()
        const org_id = userDetail?.org_id || localStorage.getItem('ORGID')
        apiService.get(`get_org_user_admin_list/${org_id}?pageSize=50&page=${currentPage}`, token).then(
            (response) => {
                // setCourseLicenseList((prevData) => [...new Set([...prevData, ...response?.data || []])]);
                setCourseLicenseList((prevData) => {
                    const uniqueOrgs = response?.data?.filter(
                        (org) => !prevData.some((prevOrg) => prevOrg.org_id === org.org_id)
                    ) || [];
                    return [...prevData, ...uniqueOrgs];
                });
                setLoading(false);
                setLoader(false);
            },
            (error) => {
                setLoading(false);
                setLoader(false);
                console.error("Error fetching data", error);
                // CustomToast.error("Error while fetching course license list")
            }
        );
    };

    const fetchIcMemberList = () => {
        setLoader(true);
        const token = apiService.getAuthToken();
        let orgData = localStorage.getItem('orgData')
        if (orgData) {
            orgData = JSON.parse(orgData)
        }
        apiService.get(`get-ic-user-list/${orgInfo?.org_id}`, token).then(
            (response) => {
                setIcUserList(response?.data || []);
                setLoader(false);
            },
            (error) => {
                setLoader(false);
                console.error("Error fetching data", error);
                CustomToast.error("Error while fetching IC member list");
            }
        );
    };

    const handleEmailChange = (e) => {
        const newEmail = e.target.value;
        setEmail(newEmail);
        validateEmail(newEmail);
    };

    const openModal = (type = 'admin') => {
        setModalType(type);
        if (type === 'admin') {
            setOrgFlag(true);
            setIcFlag(false);
        } else {
            setOrgFlag(false);
            setIcFlag(true);
        }
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setIsEditModalOpen(false);
        handleClose();
    };

    const openInviteModal = (element) => {
        setInviteModalIsOpen(true);
        setSelectedUser(element);

        console.log("element", element)
    };

    const closeInviteModal = () => {
        setInviteModalIsOpen(false);
        setSelectedUser(null);
    };

    const openDeleteOrgUserModal = (userId, uid) => {
        setSelectedUser(userId, uid);
        setDeleteOrgUserModalIsOpen(true);
    };

    const closeDeleteOrgUserModal = () => {
        setDeleteOrgUserModalIsOpen(false);
        setSelectedUser(null);
    };

    const openEditModal = (element) => {
        setSelectedUser(element);
        setUserId(element?.user_id || '');
        if (element?.orgIcType === "ic") {
            setIcFlag(true);
            setOrgFlag(false);

            setIcDesignation(element?.ic_designation || '');
            setPostOfIcMember(element?.post_of_ic_member || '');
            setIcLocation(element?.ic_location || '');
            setTenureFrom(element?.tenure_from ? new Date(element.tenure_from).toISOString().split('T')[0] : '');
            setTenureTo(element?.tenure_to ? new Date(element.tenure_to).toISOString().split('T')[0] : '');
        } else if (element?.orgIcType === "org") {
            setOrgFlag(true);
            setIcFlag(false);

            setIcDesignation('');
            setPostOfIcMember('');
            setIcLocation('');
            setTenureFrom('');
            setTenureTo('');
        } else if (element?.orgIcType === "both") {
            setOrgFlag(true);
            setIcFlag(true);

            // Try to prefill IC fields from element, fallback to icUserList if blank
            let icData = {
                ic_designation: element?.ic_designation,
                post_of_ic_member: element?.post_of_ic_member,
                ic_location: element?.ic_location,
                tenure_from: element?.tenure_from,
                tenure_to: element?.tenure_to
            };
            // If any IC field is missing, try to get from icUserList
            if (!icData.ic_designation || !icData.post_of_ic_member || !icData.ic_location || !icData.tenure_from || !icData.tenure_to) {
                const foundIc = icUserList?.find(u => u.user_id === element.user_id);
                if (foundIc) {
                    icData = {
                        ic_designation: icData.ic_designation || foundIc.ic_designation || '',
                        post_of_ic_member: icData.post_of_ic_member || foundIc.post_of_ic_member || '',
                        ic_location: icData.ic_location || foundIc.ic_location || '',
                        tenure_from: icData.tenure_from || foundIc.tenure_from || '',
                        tenure_to: icData.tenure_to || foundIc.tenure_to || ''
                    };
                }
            }
            setIcDesignation(icData.ic_designation || '');
            setPostOfIcMember(icData.post_of_ic_member || '');
            setIcLocation(icData.ic_location || '');
            setTenureFrom(icData.tenure_from ? new Date(icData.tenure_from).toISOString().split('T')[0] : '');
            setTenureTo(icData.tenure_to ? new Date(icData.tenure_to).toISOString().split('T')[0] : '');
        } else {
            setIcFlag(false);
            setOrgFlag(true);

            setIcDesignation('');
            setPostOfIcMember('');
            setIcLocation('');
            setTenureFrom('');
            setTenureTo('');
        }
        setName(element?.name || '');
        setEmail(element?.email || '');
        setPhone(element?.mobile || '');

        setIsEditModalOpen(true);
    };

    const toggleDropdown = (index, type) => {
        if (openDropdownIndex === index && openDropdownType === type) {
            setOpenDropdownIndex(null);
            setOpenDropdownType(null);
        } else {
            setOpenDropdownIndex(index);
            setOpenDropdownType(type);
        }
    };

    const handleDropdownAction = (action, element) => {
        setOpenDropdownIndex(null);
        setOpenDropdownType(null);
        if (action === 'edit') {
            openEditModal(element);
            console.log("Edit action clicked for user:", element);
        } else if (action === 'deactivate') {
            openDeleteOrgUserModal(element?.org_user_id, element?.user_id);
        }
    };

    const validateEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValid = emailPattern.test(email);
        if (!isValid) {
            setEmailError('Please enter a valid email address.');
        } else {
            setEmailError('');
        }
        return isValid
    };

    const handlePhoneChange = (e) => {
        const newPhoneNumber = e.target.value;
        setPhone(newPhoneNumber);
        validatePhone(newPhoneNumber);
    };

    const validatePhone = (phone) => {
        const phonePattern = /^[0-9]{10}$/;
        const isValid = phonePattern.test(phone);
        if (!isValid) {
            setPhoneError('Please enter a valid 10-digit phone number.');
        } else {
            setPhoneError('');
        }
        return isValid
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (email && !validateEmail(email)) {
            return
        }
        if (phone && !validatePhone(phone)) {
            return;
        }

        if (ic_flag === true && (!ic_designation || !post_of_ic_member || !ic_location || !tenure_from || !tenure_to)) {
            CustomToast.error('Please fill all the IC Member fields');
            return;
        }

        if (!(ic_flag || org_flag)) {
            CustomToast.error('Please select either Admin or IC Member');
            return;
        }

        let orgData = localStorage.getItem('orgInfo')
        if (orgData) {
            orgData = JSON.parse(orgData)
        }
        setLoader(true);
        const payload = {
            orgid: orgData?.org_id,
            org_name: orgData?.org_name,
            org_flag: org_flag === true ? true : false,
            ...(ic_flag && {
                ic_flag: ic_flag,
                ic_designation: ic_designation,
                post_of_ic_member: post_of_ic_member,
                ic_location: ic_location,
                tenure_from: tenure_from,
                tenure_to: tenure_to
            }),
            users: [
                {
                    fullname: name,
                    email: email,
                    mobile: phone
                }
            ]
        };
        const token = apiService.getAuthToken()
        localStorage.setItem("inviteData", JSON.stringify(payload))
        apiService.post("send-org-link", payload, token).then((response) => {
            if (response && response.status === "success") {
                setCourseLicenseList([])
                fetchCourseLicenses()
                setLoader(false);
                // closeModal();
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
                CustomToast.success('Invitation sent successfully')
            }
            setLoader(false);
            setName('')
            setEmail('')
            setPhone('')
        }).catch((error) => {
            setLoader(false);
            setName('')
            setEmail('')
            setPhone('')
            if (error && error.message && error.message.includes('User already exist')) {
                CustomToast.info('User already exist.')
            }
            else if (error && error.message && error.message.includes('Error occurred while sending invitations: Error: Error while sending invite: Error: Mobile already exist')) {
                CustomToast.info('Mobile already exist.')
            }
            else {
                CustomToast.error('Something went wrong.')
            }

            // CustomToast.error('Error while sending invitation request')
        })
    };

    const handleEditSubmit = (e) => {
        e.preventDefault();

        if (ic_flag === true && (!ic_designation || !post_of_ic_member || !ic_location || !tenure_from || !tenure_to)) {
            CustomToast.error('Please fill all the IC Member fields');
            return;
        }

        if (!(ic_flag || org_flag)) {
            CustomToast.error('Please select either Admin or IC Member');
            return;
        }

        let orgData = localStorage.getItem('orgInfo')
        if (orgData) {
            orgData = JSON.parse(orgData)
        }
        setLoader(true);
        const payload = {
            org_flag: org_flag === true ? true : false,
            ...(ic_flag && {
                ic_flag: ic_flag,
                ic_designation: ic_designation,
                post_of_ic_member: post_of_ic_member,
                ic_location: ic_location,
                tenure_from: tenure_from,
                tenure_to: tenure_to
            })
        };
        apiService.post(`edit-organization-admin/${userId}`, payload, apiService.getAuthToken()).then((response) => {
            if (response && response.success === true) {
                setLoader(false);
                closeModal();
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
                CustomToast.success('Org admin updated successfully')
            }
            setLoader(false);
            setName('')
            setEmail('')
            setPhone('')
        }).catch((error) => {
            setLoader(false);
            setName('')
            setEmail('')
            setPhone('')
            if (error && error.message && error.message.includes('User already exist')) {
                CustomToast.info('User already exist.')
            }
            else if (error && error.message && error.message.includes('Error occurred while sending invitations: Error: Error while sending invite: Error: Mobile already exist')) {
                CustomToast.info('Mobile already exist.')
            }
            else {
                CustomToast.error('Something went wrong.')
            }

            // CustomToast.error('Error while sending invitation request')
        })
    };

    const handleClose = () => {
        setName('');
        setEmail('');
        setPhone('');
        setOrgFlag(true); // Reset to default
        setIcFlag('');
        setIcDesignation('');
        setPostOfIcMember('');
        setIcLocation('');
        setTenureFrom('');
        setTenureTo('');
    };

    const resendOrgInvite = async (element) => {
       // console.log("element", element)
        
        let emailType = "org"; 
        let orgIcType = "org"; 
        
        if (element?.orgIcType === "ic") {
            emailType = "ic";
            orgIcType = "ic";
        } else if (element?.orgIcType === "both") {
            emailType = "both";
            orgIcType = "both";
        } else {
            emailType = "org";
            orgIcType = "org";
        }
        
        const inviteInfo = {
            orgid: orgInfo?.org_id,
            org_name: orgInfo?.org_name,
            fullname: element?.name,
            email: element?.email,
            mobile: element?.mobile,
            emailType: emailType,
            orgIcType: orgIcType,
            org_image: null,
            invite_link: element?.invite_link,
        }
        
        try {
            const token = apiService.getAuthToken()
            const result = await apiService.post("org-reinvite", inviteInfo, token);
            if (result && result.status === "success") {
                CustomToast.success('Invitation sent successfully');
                closeInviteModal(); 
               
                if (orgIcType === "ic") {
                    fetchIcMemberList();
                } else {
                    fetchCourseLicenses();
                }
                //console.log("orgReinviteData", result);
            }
        } catch (error) {
            console.error(error);
            CustomToast.error('Something went wrong.')
        }
    };

    const handleScroll = () => {
        const scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
        const scrollHeight = (document.documentElement && document.documentElement.scrollHeight) || document.body.scrollHeight;
        const clientHeight = document.documentElement.clientHeight || window.innerHeight;
        const scrollTrigger = 0.9;
        if (scrollTop + clientHeight >= scrollHeight * scrollTrigger && !loading && totalCount > currentPage) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    }

    function onSearch(e) {
        const value = e.target.value
        if (value) {
            const filteredOptions = courseLicenseList.filter(option =>
                option?.name?.toLowerCase().includes(value.toLowerCase()) ||
                option?.email?.toLowerCase().includes(value.toLowerCase()) ||
                option?.mobile?.toLowerCase().includes(value.toLowerCase())
            );
            setCourseLicenseList([])
            setCourseLicenseList(filteredOptions)
        } else {
            setCourseLicenseList([])
            fetchCourseLicenses(localStorage.getItem('ORGID'))
            setCurrentPage(1)
        }
    }

    const handleSort = () => {
        setCourseLicenseList((prevData) => {
            return [...prevData].reverse();
        });
    };

    const handleSortIcMemberList = () => {
        setIcUserList((prevData) => {
            return [...prevData].reverse();
        });
    };

    const sendOrgInvite = () => {
        setShow(false)
    }

    const handleLogout = () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem("selectedCourseObj")
        localStorage.removeItem("selectedCourse")
        localStorage.removeItem("orgData")
        sessionStorage.removeItem("userDetail")
        localStorage.removeItem("ORGID")
        localStorage.removeItem("user_details")
        localStorage.removeItem("inviteCourseList")
        localStorage.removeItem("image")
        localStorage.removeItem("inviteData")
        localStorage.removeItem("selectedLanguageInfo")
        window.location.href = process.env.REACT_APP_LOGIN_URL
    };

    const handleDeleteUser = (userId, uid) => {
        console.log(`Action: delete, User IDdsdvsag: ${userId}, UID: ${uid}`, selectedUser);
        let user_details = sessionStorage.getItem('userDetail')
        if (user_details) {
            user_details = JSON.parse(user_details)
        }
        console.log("user_details", user_details);
        const token = apiService.getAuthToken()
        const obj = { uid: uid }
        apiService.delete(`remove-org-role/${userId}`, obj, token).then((res) => {
            if (res && res?.status == "success") {
                if (user_details?.uid == uid) {
                    CustomToast.success('Org Admin has been deleted')
                    setTimeout(() => {
                        handleLogout()
                    }, 1000);
                } else {
                    CustomToast.success('Org Admin has been deactived role')
                    setCourseLicenseList([])
                    fetchCourseLicenses(userData)
                }
            }
        }).catch((err) => {
            console.log(err)
        })
    };

    return (
        <>
            {!show && (
                <div className="d-flex justify-content-between fw-bold font-26 ss">
                    <h4 className='fw-bold'>Add Admin / IC Members <br></br><small className="textDes" >Add admins and IC members and assign relevant roles to manage the platform efficiently.</small></h4>
                </div>
            )}
            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="Add Admin Modal"
                className="videoModal w-75 bg-white"
            >
                {/* <button type="button" className="close text-white" onClick={closeModal}>
                    {<svg width="20" height="20" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.548828" width="27.4625" height="27.4517" rx="13.7259" fill="#146B90" />
                        <path d="M19.619 17.6867C20.0081 18.0758 20.0081 18.6811 19.619 19.0702C19.4245 19.2647 19.1867 19.3512 18.9273 19.3512C18.6679 19.3512 18.4301 19.2647 18.2355 19.0702L14.2796 15.1143L10.3237 19.0702C10.1292 19.2647 9.89141 19.3512 9.63201 19.3512C9.3726 19.3512 9.13482 19.2647 8.94027 19.0702C8.55116 18.6811 8.55116 18.0758 8.94027 17.6867L12.8962 13.7308L8.94027 9.77492C8.55116 9.38582 8.55116 8.78054 8.94027 8.39144C9.32937 8.00233 9.93464 8.00233 10.3237 8.39144L14.2796 12.3473L18.2355 8.39144C18.6246 8.00233 19.2299 8.00233 19.619 8.39144C20.0081 8.78054 20.0081 9.38582 19.619 9.77492L15.6631 13.7308L19.619 17.6867Z" fill="white" />
                    </svg>}
                </button> */}
                <div>
                    <h5 className="font-weight-600 font-26 d-flex justify-content-start align-items-center mb-4 text-left"><img src="/images/add-admin-icon.svg" alt="invite" className='me-2' style={{ width: '25px', height: '25px' }} /> {modalType === 'admin' ? 'Add Admin' : 'Add IC Member'}</h5>
                    <hr className="my-4" />
                    <div className="card-body">
                        {loader ? (
                            <Loader />
                        ) : (

                            <form onSubmit={handleSubmit}>
                                <label className="form-check-label font-18 mb-0 fw-bold d-none">Role</label>
                                <div className="row mt-2 d-none">
                                    {modalType === 'admin' && (
                                        <div className="col-md-4 form-group mb-3">
                                            <div className="form-control form-switch d-flex justify-content-between align-items-center">
                                                <label className="form-check-label mb-0 fw-bold" htmlFor="orgFlagSwitch">Organisation Admin</label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id="orgFlagSwitch"
                                                    checked={org_flag}
                                                    onChange={(e) => setOrgFlag(e.target.checked)}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {modalType === 'ic' && orgInfo?.plan_id !== 'plan_1234567890' && (
                                        <div className="col-md-4 form-group mb-3">
                                            <div className="form-control form-switch d-flex justify-content-between align-items-center">
                                                <label className="form-check-label mb-0 fw-bold" htmlFor="icFlagSwitch">IC Member</label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id="icFlagSwitch"
                                                    checked={ic_flag}
                                                    onChange={(e) => setIcFlag(e.target.checked)}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="row">
                                    <div className="col-md-4 form-group mb-3">
                                        <label className="mb-2 fw-bold">Name*</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Name"
                                            value={name}
                                            name="name"
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-4 form-group mb-3">
                                        <label className="mb-2 fw-bold">Email Id*</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Enter Email ID"
                                            value={email}
                                            name="email"
                                            onChange={handleEmailChange}
                                            required
                                        />
                                        {emailError && <p className="error">{emailError}</p>}
                                    </div>
                                    <div className="col-md-4 form-group mb-3">
                                        <label className="mb-2 fw-bold">Mobile</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Number"
                                            value={phone}
                                            name="phone"
                                            onChange={handlePhoneChange}
                                        />
                                        {phoneError && <p className="error">{phoneError}</p>}
                                    </div>
                                </div>

                                {ic_flag && (
                                    <div className="row">
                                        <div className="col-md-4 form-group mb-3">
                                            <label className="mb-2 fw-bold">IC Designation*</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter IC Designation"
                                                value={ic_designation}
                                                onChange={(e) => setIcDesignation(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="col-md-4 form-group mb-3">
                                            <label className="mb-2 fw-bold">Post of IC Member*</label>
                                            <select
                                                className="form-select position-relative"
                                                value={post_of_ic_member}
                                                onChange={(e) => setPostOfIcMember(e.target.value)}
                                                required
                                            >
                                                <option value="">Select Post</option>
                                                <option value="Presiding Officer">Presiding Officer</option>
                                                <option value="Member">Member</option>
                                                <option value="External Member">External Member</option>
                                            </select>
                                        </div>

                                        <div className="col-md-4 form-group mb-3">
                                            <label className="mb-2 fw-bold">IC Location*</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder='Enter IC Location'
                                                value={ic_location}
                                                onChange={(e) => setIcLocation(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="col-md-4 form-group mb-3 position-relative">
                                            <label className="mb-4 fw-bold">Tenure of IC member*</label>
                                            <div className="position-relative">
                                                <span className="input-label">From</span>
                                                <input
                                                    type="date"
                                                    className="form-control text-uppercase input-with-label"
                                                    value={tenure_from}
                                                    onChange={(e) => setTenureFrom(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4 form-group mb-3 position-relative">
                                            <label className="mb-4 fw-bold text-white">Tenure of IC member</label>
                                            <div className="position-relative">
                                                <span className="input-label">To</span>
                                                <input
                                                    type="date"
                                                    className="form-control text-uppercase input-with-label"
                                                    value={tenure_to}
                                                    onChange={(e) => setTenureTo(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <hr className="my-4" />
                                <div className="row">
                                    <div className="col-md-3 offset-md-9 d-flex justify-content-between mt-3">
                                        <button
                                            type="button"
                                            className="btn btn-secondary border-radius-50 w-100"
                                            onClick={closeModal}
                                        >
                                            Cancel
                                        </button>
                                        <button type="submit" className="btn btn-primary border-radius-50 w-100 ms-3">
                                            Add
                                        </button>
                                    </div>
                                </div>
                            </form>

                        )}
                    </div>
                </div>
            </Modal>

            <Modal
                isOpen={isEditModalOpen}
                onRequestClose={closeModal}
                contentLabel="Edit Admin Modal"
                className="videoModal w-75 bg-white"
            >
                <div>
                    <h5 className="font-weight-600 font-26 d-flex justify-content-start align-items-center mb-4 text-left">
                        <img src="/images/edit-icon.svg" alt="edit" className='me-2' style={{ width: '25px', height: '25px' }} />
                        {selectedUser?.orgIcType === "both"
                            ? "Edit Admin/IC Details"
                            : ic_flag
                                ? "Edit IC Details"
                                : org_flag
                                    ? "Edit Admin Details"
                                    : "Edit Admin/IC Details"}
                    </h5>
                    <hr className="my-4" />
                    <div className="card-body">
                        {loader ? (
                            <Loader />
                        ) : (
                            <form onSubmit={handleEditSubmit}>
                                <label className="form-check-label font-18 mb-0 fw-bold d-none">Role</label>
                                <div className="row mt-2 d-none">
                                    <div className="col-md-4 form-group mb-3">
                                        <div className="form-control form-switch d-flex justify-content-between align-items-center">
                                            <label className="form-check-label mb-0 fw-bold" htmlFor="orgFlagSwitch">Organisation Admin</label>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id="orgFlagSwitch"
                                                checked={org_flag}
                                                onChange={(e) => setOrgFlag(e.target.checked)}
                                            />
                                        </div>
                                    </div>
                                    {orgInfo?.plan_id !== 'plan_1234567890' && (
                                        <div className="col-md-4 form-group mb-3">
                                            <div className="form-control form-switch d-flex justify-content-between align-items-center">
                                                <label className="form-check-label mb-0 fw-bold" htmlFor="icFlagSwitch">IC Member</label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id="icFlagSwitch"
                                                    checked={ic_flag}
                                                    onChange={(e) => setIcFlag(e.target.checked)}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="row">
                                    <div className="col-md-4 form-group mb-3">
                                        <label className="mb-2 fw-bold">Name*</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Name"
                                            value={name}
                                            name="name"
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                            disabled
                                        />
                                    </div>
                                    <div className="col-md-4 form-group mb-3">
                                        <label className="mb-2 fw-bold">Email Id*</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Enter Email ID"
                                            value={email}
                                            name="email"
                                            onChange={handleEmailChange}
                                            required
                                            disabled
                                        />
                                        {emailError && <p className="error">{emailError}</p>}
                                    </div>
                                    <div className="col-md-4 form-group mb-3">
                                        <label className="mb-2 fw-bold">Mobile</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Number"
                                            value={phone}
                                            name="phone"
                                            onChange={handlePhoneChange}
                                            disabled
                                        />
                                        {phoneError && <p className="error">{phoneError}</p>}
                                    </div>
                                </div>
                                {ic_flag && (
                                    <div className="row">
                                        <div className="col-md-4 form-group mb-3">
                                            <label className="mb-2 fw-bold">IC Designation*</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter IC Designation"
                                                value={ic_designation}
                                                onChange={(e) => setIcDesignation(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="col-md-4 form-group mb-3">
                                            <label className="mb-2 fw-bold">Post of IC Member*</label>
                                            <select
                                                className="form-select position-relative"
                                                value={post_of_ic_member}
                                                onChange={(e) => setPostOfIcMember(e.target.value)}
                                                required
                                            >
                                                <option value="">Select Post</option>
                                                <option value="Presiding Officer">Presiding Officer</option>
                                                <option value="Member">Member</option>
                                                <option value="External Member">External Member</option>
                                            </select>
                                        </div>

                                        <div className="col-md-4 form-group mb-3">
                                            <label className="mb-2 fw-bold">IC Location*</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder='Enter IC Location'
                                                value={ic_location}
                                                onChange={(e) => setIcLocation(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="col-md-4 form-group mb-3 position-relative">
                                            <label className="mb-4 fw-bold">Tenure of IC member*</label>
                                            <div className="position-relative">
                                                <span className="input-label">From</span>
                                                <input
                                                    type="date"
                                                    className="form-control text-uppercase input-with-label"
                                                    value={tenure_from}
                                                    onChange={(e) => setTenureFrom(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4 form-group mb-3 position-relative">
                                            <label className="mb-4 fw-bold text-white">Tenure of IC member</label>
                                            <div className="position-relative">
                                                <span className="input-label">To</span>
                                                <input
                                                    type="date"
                                                    className="form-control text-uppercase input-with-label"
                                                    value={tenure_to}
                                                    onChange={(e) => setTenureTo(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <hr className="my-4" />
                                <div className="row">
                                    <div className="col-md-3 offset-md-9 d-flex justify-content-between mt-3">
                                        <button
                                            type="button"
                                            className="btn btn-secondary border-radius-50 w-100"
                                            onClick={closeModal}
                                        >
                                            Cancel
                                        </button>
                                        <button type="submit" className="btn btn-primary border-radius-50 w-100 ms-3">
                                            Update
                                        </button>
                                    </div>
                                </div>
                            </form>

                        )}
                    </div>
                </div>
            </Modal>

            <div className="align-items-center mb-3 bg-white p-3" style={{ borderRadius: '20px' }}>
                <div className='d-flex justify-content-between align-items-center gap-2 mb-3'>
                    <p className='text-black text-black pt-2 pb-2 mb-0 font-20 fw-bold'>
                        <span className='me-2'>
                            <img src="/images/setting_icon.svg" alt="group icon" width='35' height='35' />
                        </span>
                        Assigned Admins
                    </p>
                    <button type="button" className="btn btn-link btn-primary text-white text-decoration-none btn-sm d-flex justify-content-between align-items-center" onClick={() => openModal('admin')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13.019" viewBox="0 0 15 13.019" style={{ marginRight: '10px' }}>
                            <path id="manage_accounts_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24" d="M80-789.278v-.613a2.293,2.293,0,0,1,.325-1.2,2.14,2.14,0,0,1,.9-.833,12.1,12.1,0,0,1,2.269-.881,8.978,8.978,0,0,1,2.4-.325.476.476,0,0,1,.421.239.552.552,0,0,1,.057.507,6.026,6.026,0,0,0-.172.8,5.816,5.816,0,0,0-.057.823,4.928,4.928,0,0,0,.115,1.072,5.868,5.868,0,0,0,.325,1.015.619.619,0,0,1-.029.622.566.566,0,0,1-.507.3H81.532a1.475,1.475,0,0,1-1.082-.45A1.475,1.475,0,0,1,80-789.278Zm11.488,0a1.475,1.475,0,0,0,1.082-.45,1.475,1.475,0,0,0,.45-1.082,1.475,1.475,0,0,0-.45-1.082,1.475,1.475,0,0,0-1.082-.45,1.475,1.475,0,0,0-1.082.45,1.475,1.475,0,0,0-.45,1.082,1.475,1.475,0,0,0,.45,1.082A1.475,1.475,0,0,0,91.488-789.278Zm-5.361-4.6a2.95,2.95,0,0,1-2.164-.9,2.95,2.95,0,0,1-.9-2.164,2.95,2.95,0,0,1,.9-2.164,2.95,2.95,0,0,1,2.164-.9,2.95,2.95,0,0,1,2.164.9,2.95,2.95,0,0,1,.9,2.164,2.95,2.95,0,0,1-.9,2.164A2.95,2.95,0,0,1,86.127-793.873Zm4.48,6.28-.115-.536q-.23-.1-.431-.2a3.325,3.325,0,0,1-.412-.258l-.555.172a.713.713,0,0,1-.488-.019.769.769,0,0,1-.373-.306l-.153-.268a.75.75,0,0,1-.1-.5.674.674,0,0,1,.249-.44l.421-.364a3.535,3.535,0,0,1-.038-.5,3.535,3.535,0,0,1,.038-.5l-.421-.364a.668.668,0,0,1-.249-.431.731.731,0,0,1,.1-.488l.172-.287a.775.775,0,0,1,.364-.306.685.685,0,0,1,.479-.019l.555.172a3.34,3.34,0,0,1,.412-.258q.2-.105.431-.2l.115-.555a.734.734,0,0,1,.258-.431.724.724,0,0,1,.469-.163h.306a.7.7,0,0,1,.469.172.778.778,0,0,1,.258.44l.115.536a3.86,3.86,0,0,1,.431.211,3.028,3.028,0,0,1,.412.287l.517-.172a.721.721,0,0,1,.517,0,.738.738,0,0,1,.383.326l.153.268a.75.75,0,0,1,.1.5.674.674,0,0,1-.249.44l-.421.364a2.908,2.908,0,0,1,.038.479,2.909,2.909,0,0,1-.038.479l.421.364a.668.668,0,0,1,.249.431.731.731,0,0,1-.1.488l-.172.287a.775.775,0,0,1-.364.306.685.685,0,0,1-.479.019l-.555-.172a3.324,3.324,0,0,1-.412.258q-.2.105-.431.2l-.115.555a.734.734,0,0,1-.258.431.723.723,0,0,1-.469.163h-.306a.7.7,0,0,1-.469-.172A.778.778,0,0,1,90.607-787.593Z" transform="translate(-80 800)" fill="#fff" />
                        </svg> Add Admin
                    </button>
                </div>
                <table className="table table-responsive">
                    <thead className="">
                        <tr>
                            <th className="text-center">Sr. No.</th>
                            <th><Link className='text-decoration-none text-black'><span onClick={handleSort} className='d-flex justify-content-between align-items-center'>Full Name <img src='/images/sort.svg' alt='sort' className='me-5' width={20} height={20} /></span></Link></th>
                            <th>Email ID</th>
                            <th>Phone No</th>
                            <th>Status</th>
                            <th className="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loader ? (
                            <Loader />
                        ) : (
                            courseLicenseList?.map((element, index) => {
                                if (element?.email != null || element?.mobile != null) {
                                    return (
                                        <tr key={index}>
                                            <td align="center">{index + 1}</td>
                                            <td>{element?.name}</td>
                                            <td>{element?.email}</td>
                                            <td>
                                                {element?.mobile &&
                                                    element?.mobile.toLowerCase() !== "undefined" &&
                                                    element?.mobile.toLowerCase() !== "null"
                                                    ? element?.mobile
                                                    : ""}
                                            </td>
                                            <td>{element?.user_id ? <span style={{ color: '#23A298', fontSize: '14px', textTransform: 'capitalize' }}>Accepted</span> : <span style={{ color: '#156B90', fontSize: '14px', textTransform: 'capitalize' }}>Invited</span>}</td>
                                            <td align="center">
                                                {element?.user_id ? (
                                                    <div className="action-dropdown">
                                                        <button
                                                            className="dots-menu-btn"
                                                            onClick={() => toggleDropdown(index, 'admin')}
                                                        >
                                                            <svg width="16" height="4" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="2" cy="2" r="2" fill="#666" />
                                                                <circle cx="8" cy="2" r="2" fill="#666" />
                                                                <circle cx="14" cy="2" r="2" fill="#666" />
                                                            </svg>
                                                        </button>
 
                                                        {openDropdownIndex === index && openDropdownType === 'admin' && (
                                                            <div className="action-dropdown-menu">
                                                                {/* <button
                                                                    className="action-dropdown-item"
                                                                    onClick={() => handleDropdownAction('edit', element)}
                                                                >
                                                                    <img src="/images/edit-icon.svg" alt="edit" width={16} height={16} />
                                                                    Edit
                                                                </button> */}

                                                                <button
                                                                    className="action-dropdown-item danger"
                                                                    onClick={() => handleDropdownAction('deactivate', element)}
                                                                >
                                                                    <img src="/images/delete.svg" alt="deactivate" width={16} height={16} />
                                                                    Delete
                                                                </button>
                                                            </div>
                                                        )} 
                                                    </div>
                                                ) : (
                                                    <Link onClick={() => openInviteModal(element)}>
                                                        <img src="/images/invite.svg" alt="invite" width={20} height={20} />
                                                    </Link>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                } else {
                                    return null;
                                }
                            })
                        )}
                    </tbody>
                </table>
            </div>

            {orgInfo?.plan_id !== 'plan_1234567890' && ( <>
            <div className="align-items-center mb-2 bg-white p-3" style={{ borderRadius: '20px' }}>
                    <div className='d-flex justify-content-between align-items-center gap-2 mb-2'>
                        <p className='text-black pt-2 pb-2 mb-0 font-20 fw-bold'>
                            <span className='me-2'>
                                <img src="/images/setting_icon1.svg" alt="group icon" width='35' height='35' />
                            </span>
                            Assigned IC Members
                        </p>
                        {orgInfo?.plan_id !== 'plan_1234567890' && (
                            <button type="button" className="btn btn-link btn-primary text-white text-decoration-none btn-sm d-flex justify-content-between align-items-center" onClick={() => openModal('ic')}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13.019" viewBox="0 0 15 13.019" style={{ marginRight: '10px' }}>
                                    <path id="manage_accounts_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24" d="M80-789.278v-.613a2.293,2.293,0,0,1,.325-1.2,2.14,2.14,0,0,1,.9-.833,12.1,12.1,0,0,1,2.269-.881,8.978,8.978,0,0,1,2.4-.325.476.476,0,0,1,.421.239.552.552,0,0,1,.057.507,6.026,6.026,0,0,0-.172.8,5.816,5.816,0,0,0-.057.823,4.928,4.928,0,0,0,.115,1.072,5.868,5.868,0,0,0,.325,1.015.619.619,0,0,1-.029.622.566.566,0,0,1-.507.3H81.532a1.475,1.475,0,0,1-1.082-.45A1.475,1.475,0,0,1,80-789.278Zm11.488,0a1.475,1.475,0,0,0,1.082-.45,1.475,1.475,0,0,0,.45-1.082,1.475,1.475,0,0,0-.45-1.082,1.475,1.475,0,0,0-1.082-.45,1.475,1.475,0,0,0-1.082.45,1.475,1.475,0,0,0-.45,1.082,1.475,1.475,0,0,0,.45,1.082A1.475,1.475,0,0,0,91.488-789.278Zm-5.361-4.6a2.95,2.95,0,0,1-2.164-.9,2.95,2.95,0,0,1-.9-2.164,2.95,2.95,0,0,1,.9-2.164,2.95,2.95,0,0,1,2.164-.9,2.95,2.95,0,0,1,2.164.9,2.95,2.95,0,0,1,.9,2.164,2.95,2.95,0,0,1-.9,2.164A2.95,2.95,0,0,1,86.127-793.873Zm4.48,6.28-.115-.536q-.23-.1-.431-.2a3.325,3.325,0,0,1-.412-.258l-.555.172a.713.713,0,0,1-.488-.019.769.769,0,0,1-.373-.306l-.153-.268a.75.75,0,0,1-.1-.5.674.674,0,0,1,.249-.44l.421-.364a3.535,3.535,0,0,1-.038-.5,3.535,3.535,0,0,1,.038-.5l-.421-.364a.668.668,0,0,1-.249-.431.731.731,0,0,1,.1-.488l.172-.287a.775.775,0,0,1,.364-.306.685.685,0,0,1,.479-.019l.555.172a3.34,3.34,0,0,1,.412-.258q.2-.105.431-.2l.115-.555a.734.734,0,0,1,.258-.431.724.724,0,0,1,.469-.163h.306a.7.7,0,0,1,.469.172.778.778,0,0,1,.258.44l.115.536a3.86,3.86,0,0,1,.431.211,3.028,3.028,0,0,1,.412.287l.517-.172a.721.721,0,0,1,.517,0,.738.738,0,0,1,.383.326l.153.268a.75.75,0,0,1,.1.5.674.674,0,0,1-.249.44l-.421.364a2.908,2.908,0,0,1,.038.479,2.909,2.909,0,0,1-.038.479l.421.364a.668.668,0,0,1,.249.431.731.731,0,0,1-.1.488l-.172.287a.775.775,0,0,1-.364.306.685.685,0,0,1-.479.019l-.555-.172a3.324,3.324,0,0,1-.412.258q-.2.105-.431.2l-.115.555a.734.734,0,0,1-.258.431.723.723,0,0,1-.469.163h-.306a.7.7,0,0,1-.469-.172A.778.778,0,0,1,90.607-787.593Z" transform="translate(-80 800)" fill="#fff" />
                                </svg> Add IC
                            </button>
                        )}
                    </div>
                <table className="table table-responsive">
                    {loader ? (
                        <Loader />
                    ) : (
                        <>
                            {icUserList && icUserList?.length > 0 ? (
                                <>
                                    <thead className="">
                                        <tr>
                                            <th className="text-center">Sr. No.</th>
                                            <th className='text-left'><Link className='text-decoration-none text-black'><span onClick={handleSortIcMemberList} className='d-flex justify-content-between align-items-center'>Full Name <img src='/images/sort.svg' alt='sort' className='me-5' width={20} height={20} /></span></Link></th>
                                            <th className="text-left">Designation</th>
                                            <th className="text-left">Location</th>
                                            <th className="text-left w-25">Email ID</th>
                                            <th className="text-left">Phone No</th>
                                            <th className="text-center">Date of Commencement</th>
                                            <th className="text-left">Status</th>
                                            <th className="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {icUserList.map((element, index) => (
                                            <tr key={index}>
                                                <td align="center">{index + 1}</td>
                                                <td>
                                                    <span className='fw-bold'>{element?.name}</span><br />
                                                    <span>{element?.post_of_ic_member}</span>
                                                </td>
                                                <td>{element?.ic_designation}</td>
                                                <td>{element?.ic_location}</td>
                                                <td>{element?.email}</td>
                                                <td>
                                                    {element?.mobile &&
                                                        element?.mobile.toLowerCase() !== "undefined" &&
                                                        element?.mobile.toLowerCase() !== "null"
                                                        ? element?.mobile
                                                        : ""}
                                                </td>
                                                 <td align="center">
                                                    {new Date(element?.tenure_from).toLocaleDateString('en-GB')} - {new Date(element?.tenure_to).toLocaleDateString('en-GB')}
                                                </td>
                                                <td>
                                                    {element?.status === 'ACCEPTED' ? (
                                                        <span style={{ color: '#23A298', fontSize: '14px', textTransform: 'capitalize' }}>Accepted</span>
                                                    ) : (
                                                        <span style={{ color: '#156B90', fontSize: '14px', textTransform: 'capitalize' }}>Invited</span>
                                                    )}
                                                </td>
                                               
                                                {/* <td align="center">
                                                    {element?.status === 'ACCEPTED' ? (
                                                        <Link onClick={() => openDeleteOrgUserModal(element)}>
                                                            <img src="/images/delete.svg" alt="delete" width={20} height={20} />
                                                        </Link>
                                                    ) : (
                                                        <Link onClick={() => openInviteModal(element)}>
                                                            <img src="/images/invite.svg" alt="invite" width={20} height={20} />
                                                        </Link>
                                                    )}
                                                </td> */}
                                                <td align="center">
                                                    {element?.user_id ? (
                                                        <div className="action-dropdown">
                                                            <button
                                                                className="dots-menu-btn"
                                                                onClick={() => toggleDropdown(index, 'ic')}
                                                            >
                                                                <svg width="16" height="4" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="2" cy="2" r="2" fill="#666" />
                                                                    <circle cx="8" cy="2" r="2" fill="#666" />
                                                                    <circle cx="14" cy="2" r="2" fill="#666" />
                                                                </svg>
                                                            </button>

                                                            {openDropdownIndex === index && openDropdownType === 'ic' && (
                                                                <div className="action-dropdown-menu">
                                                                    <button
                                                                        className="action-dropdown-item"
                                                                        onClick={() => handleDropdownAction('edit', element)}
                                                                    >
                                                                        <img src="/images/edit-icon.svg" alt="edit" width={16} height={16} />
                                                                        Edit
                                                                    </button>

                                                                    <button
                                                                        className="action-dropdown-item danger"
                                                                        onClick={() => handleDropdownAction('deactivate', element)}
                                                                    >
                                                                        <img src="/images/delete.svg" alt="deactivate" width={16} height={16} />
                                                                        Delete
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <Link onClick={() => openInviteModal(element)}>
                                                            <img src="/images/invite.svg" alt="invite" width={20} height={20} />
                                                        </Link>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </>
                            ) : (
                                <tbody>
                                    <tr>
                                        <td colSpan="12">
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '40px'
                                                }}
                                            >
                                                <img
                                                    src="/images/empty_records_icon.png"
                                                    alt="Empty Records"
                                                    style={{
                                                        width: '108px',
                                                        height: '138px',
                                                        marginBottom: '12px',
                                                    }}
                                                />
                                                <p className='mt-4 text-muted' style={{ margin: 0, fontSize: '16px', color: '#555' }}>
                                                    Your Internal Committee list is currently empty. Add members to proceed.
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </>
                    )}
                </table> 
            </div></>)}

                {selectedUser &&
                    <Modal
                        isOpen={inviteModalIsOpen}
                        onRequestClose={closeInviteModal}
                        contentLabel="Invite Org Modal"
                    >
                        <InviteUserModal onRequestClose={closeInviteModal} onConfirm={() => resendOrgInvite(selectedUser)} />
                    </Modal>}

                {/* {selectedUser && */}
                    <Modal
                        isOpen={deleteOrgUserModalIsOpen}
                        onRequestClose={closeDeleteOrgUserModal}
                        contentLabel="Delete Org Modal"
                    >
                        <DeleteOrgUserModal onRequestClose={closeDeleteOrgUserModal} onConfirm={() => handleDeleteUser(selectedUser)} />
                    </Modal>
                {/* } */}
            
        </>

    )
}

export default Admin;